import styled from 'styled-components'
import { Tokens } from '@/assets/tokens'

export const PopoverContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const PopoverTrigger = styled.button`
  border: none;
  background: transparent;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: ${Tokens.ColorHover};
    border-radius: 6px;
  }
`

export const PopoverBalloon = styled.div<{ $placement?: 'left' | 'right' }>`
  position: absolute;
  top: calc(100% + 8px);
  ${({ $placement }) => ($placement === 'left' ? 'left: 0;' : 'right: 0;')}
  z-index: 9999;
  min-width: 320px;
  max-width: 450px;
  max-height: 60vh;
  overflow-y: auto;
  background: ${Tokens.ColorWhite};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  padding: 12px;
  animation: fadeIn 120ms ease;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${Tokens.ColorLight};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${Tokens.ColorTextTertiary};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${Tokens.ColorTextSecondary};
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const PopoverArrow = styled.div<{ $placement?: 'left' | 'right' }>`
  position: absolute;
  top: -6px;
  ${({ $placement }) => ($placement === 'left' ? 'left: 16px;' : 'right: 16px;')}
  width: 12px;
  height: 12px;
  background: ${Tokens.ColorWhite};
  border-left: 1px solid ${Tokens.ColorBorder};
  border-top: 1px solid ${Tokens.ColorBorder};
  transform: rotate(45deg);
`

export const Loading = styled.div`
  padding: 8px 12px;
  color: ${Tokens.ColorTextSecondary};
  font-size: 13px;
`

export const Empty = styled.div`
  padding: 8px 12px;
  color: ${Tokens.ColorTextSecondary};
  font-size: 13px;
`

export const Entry = styled.div`
  border: 1px solid ${Tokens.ColorLight};
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  background: ${Tokens.ColorWhite};

  &:last-child {
    margin-bottom: 0;
  }
`

export const EntryMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;

  strong {
    font-size: 14px;
    color: ${Tokens.ColorTextPrimary};
    flex: 1;
    min-width: 0;
  }

  span {
    color: ${Tokens.ColorTextSecondary};
    font-size: 12px;
    white-space: nowrap;
    margin: 0 8px;
  }

  small {
    background: ${Tokens.ColorLight};
    color: ${Tokens.ColorTextSecondary};
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    white-space: nowrap;
  }
`

export const EntryDetails = styled.div`
  font-size: 12px;
  color: ${Tokens.ColorTextPrimary};

  .fields {
    margin-bottom: 8px;

    strong {
      color: ${Tokens.ColorTextSecondary};
      font-weight: 600;
    }
  }

  .diff-preview {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .diff-row {
      display: flex;
      gap: 12px;
      align-items: flex-start;
      font-size: 12px;
      line-height: 1.4;
    }

    .diff-field {
      min-width: 80px;
      max-width: 120px;
      color: ${Tokens.ColorTextSecondary};
      font-weight: 600;
      flex-shrink: 0;
    }

    .diff-values {
      flex: 1;
      word-break: break-word;
      line-height: 1.4;
    }

    .more {
      color: ${Tokens.ColorTextSecondary};
      font-size: 11px;
      font-style: italic;
      margin-top: 4px;
    }
  }

  .no-diff {
    color: ${Tokens.ColorTextSecondary};
    font-size: 12px;
    font-style: italic;
  }
`
